import { styled } from "@mui/material";
import { Breadcrumbs as VoltBreadcrumbs } from "@volt_developers/components";

import { TEST_IDS } from "../../constants";
import { useBreadcrumbsContext } from "../../context";
import { Breadcrumb } from "../Breadcrumb";

export function Breadcrumbs() {
  const { breadcrumbs } = useBreadcrumbsContext();

  if (!breadcrumbs.length) {
    return (
      <Wrapper data-testid={TEST_IDS.breadcrumbsListPlaceholder}>
        <VoltBreadcrumbs.Text sxText={{ margin: "2px 0" }}>
          <Placeholder />
        </VoltBreadcrumbs.Text>
      </Wrapper>
    );
  }

  return (
    <VoltBreadcrumbs.Wrapper>
      {breadcrumbs.map(({ id, ...breadcrumb }, index) => (
        <Breadcrumb
          {...breadcrumb}
          key={id}
          isFirst={index === 0}
          isLast={index === breadcrumbs.length - 1}
        />
      ))}
    </VoltBreadcrumbs.Wrapper>
  );
}

const Wrapper = styled("ul")({
  display: "flex",
  listStyle: "none",
  padding: 0,
  margin: 0,

  "& > li": {
    alignItems: "center",
  },
});

const Placeholder = styled("span")({
  width: 24,
  height: 24,
  display: "block",
});
